import React, { useState, useEffect } from "react";
import Header from "./Header.js";
import Loader from "./Loader.js";
import GreyArrow from "../assets/greyLeftAr.png";
import FilterIcon from "../assets/filterIcon.png";
import Search from "../assets/search.png";
import GuestIcon from "../assets/guestIcon.png";
import DatePicker from "react-datepicker";
import { ArrowLeft } from "lucide-react";
import {
  options_search,
  GuestManagementPageText,
} from "../CommonJquery/WebsiteText.js";
import {
  server_post_data,
  update_guest_vip_status,
  get_all_notes_by_id,
  get_payment_booking_report,
  save_user_data_for_edit,
  APL_LINK,
} from "../ServiceConnection/serviceconnection.js";
import {
  handleError,
  computeTodayDate,
  handleIaphabetnumberChange,
  handleAphabetsChange,
  handleEmailChange,
  handleNumbersChange,
  mondayDayYearFormat,
  computeplussevendays,
  goBack,
  formatToYYYYMMDD,
  handleSuccess,
} from "../CommonJquery/CommonJquery.js";
import { Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import * as XLSX from "xlsx";
function BookingsReport() {
  const navigate = useNavigate();
  const [showLoaderAdmin, setshowLoaderAdmin] = useState(false);
  const [editStaffData, seteditStaffData] = useState([]);
  // Set initial state using useState hook
  const [startDate, setStartDate] = useState(computeplussevendays());
  const [endDate, setEndDate] = useState(computeTodayDate());
  const [searchfilter, setSearchFilter] = useState("");
  const [filteredData, setfilteredData] = useState([]);
  const [flagData, setflagData] = useState("1");
  const [selectedValue, setSelectedValue] = useState("Name"); // State to hold the selected value
  const handleSelect = (event) => {
    setSelectedValue(event.target.value); // Update the selected value when an option is selected
  };
  // Pagination
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);

  // Get paginated data
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredData
    ? filteredData.slice(indexOfFirstItem, indexOfLastItem)
    : [];
  const totalPages = filteredData
    ? Math.ceil(filteredData.length / itemsPerPage)
    : 0;

  //console.log("currentItems:", currentItems);

  // Handler for page changes
  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  // Render pagination buttons
  const renderPaginationButtons = () => {
    const buttons = [];

    // Previous button
    buttons.push(
      <li className="cust_hist_page_item" key="prev">
        <button
          className="cust_hist_page_link cust_hist_page_prev"
          onClick={() => handlePageChange(currentPage - 1)}
          disabled={currentPage === 1}
        >
          <span className="sr-only">Previous</span>
          <svg
            className="cust_hist_page_icon"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 20 20"
            fill="currentColor"
            aria-hidden="true"
          >
            <path
              fillRule="evenodd"
              d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z"
              clipRule="evenodd"
            />
          </svg>
        </button>
      </li>
    );

    // Page buttons
    // Show max 5 page buttons with current page in the middle when possible
    let startPage = Math.max(1, currentPage - 2);
    let endPage = Math.min(totalPages, startPage + 4);

    // Adjust startPage if endPage is at maximum
    if (endPage === totalPages) {
      startPage = Math.max(1, endPage - 4);
    }

    for (let i = startPage; i <= endPage; i++) {
      buttons.push(
        <li className="cust_hist_page_item" key={i}>
          <button
            className={`cust_hist_page_link ${
              currentPage === i ? "cust_hist_page_active" : ""
            }`}
            onClick={() => handlePageChange(i)}
          >
            {i}
          </button>
        </li>
      );
    }

    // Next button
    buttons.push(
      <li className="cust_hist_page_item" key="next">
        <button
          className="cust_hist_page_link cust_hist_page_next"
          onClick={() => handlePageChange(currentPage + 1)}
          disabled={currentPage === totalPages || totalPages === 0}
        >
          <span className="sr-only">Next</span>
          <svg
            className="cust_hist_page_icon"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 20 20"
            fill="currentColor"
            aria-hidden="true"
          >
            <path
              fillRule="evenodd"
              d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
              clipRule="evenodd"
            />
          </svg>
        </button>
      </li>
    );

    return buttons;
  };

  useEffect(() => {
    const flag = "1";
    let call_id = "0";
    master_data_get(startDate, endDate, flag, call_id);
  }, []);

  const search_data = () => {
    const flag = "2";
    const call_id = "0";
    setCurrentPage(1);
    master_data_get(startDate, endDate, flag, call_id);
  };

  const master_data_get = async (start_date, end_date, flag, call_id) => {
    setshowLoaderAdmin(true);
    const fd = new FormData();
    setflagData(flag);
    // fd.append("start_date", formatToYYYYMMDD(start_date));
    fd.append("start_date", "");
    // fd.append("end_date", formatToYYYYMMDD(end_date));
    fd.append("end_date", "");
    fd.append("flag", flag);
    fd.append("call_id", call_id);
    fd.append("search_option", selectedValue);
    // fd.append("search_data", document.getElementById("search_data").value);
    await server_post_data(get_payment_booking_report, fd)
      .then((Response) => {
        if (Response.data.error) {
          handleError(Response.data.message);
        } else {
          console.log("Console:", Response.data.message);

          seteditStaffData(Response.data.message.report_data);
          setfilteredData(Response.data.message.report_data);
        }

        setshowLoaderAdmin(false);
      })
      .catch((error) => {
        handleError("network");
        setshowLoaderAdmin(false);
      });
  };

  // const handleSearch = (event) => {
  //   const searchValue = event.target.value;
  //   setSearchFilter(searchValue);
  //   setCurrentPage(1);
  //   // Filter table data based on search value
  //   const filteredDatashow = editStaffData.filter((row) => {
  //     return Object.values(row).some((value) => {
  //       if (value !== null && value !== undefined) {
  //         // Add null check here
  //         return (
  //           typeof value === "string"
  //             ? value.toLowerCase()
  //             : value.toString().toLowerCase()
  //         ).includes(searchValue.toLowerCase());
  //       }
  //       return false;
  //     });
  //   });

  //   setfilteredData(filteredDatashow);
  // };

  const handleSearch = (event) => {
    const searchValue = event.target.value.toLowerCase();
    setSearchFilter(searchValue);
    setCurrentPage(1);

    const filteredDatashow = editStaffData.filter((row) => {
      const driver = row.driver_details?.[0] || {};
      const car = row.car_details?.[0] || {};
      // const booking = row.booking_details?.[0] || {};

      const fieldsToSearch = [
        driver.name,
        driver.email,
        driver.mobile_no,
        car.car_tagline, // fleet number
        car.car_name,
        car.car_no,
        row.per_day_rent + row.per_day_surcharges,
        row.payment_mode,
        row.total_amount?.toString(),
        row.rent?.toString(),
        row.tolls?.toString(),
        row.damagefees?.toString(),
        row.deposit?.toString(),
        row.entry_date?.split("T")[0], // date for "Last Pay"
      ];

      return fieldsToSearch.some((field) =>
        field?.toString().toLowerCase().includes(searchValue)
      );
    });

    setfilteredData(filteredDatashow);
  };

  const handleDateChange = (date) => {
    setStartDate(date);
  };

  const downloadCSV = () => {
    const headers = [
      "Driver Name",
      "Fleet",
      "Car Name",
      "Rate per day",
      "Payment Cycle Day",
      "Last Payment Date",
      "Days",
      "Payment Mode",
      "Total Balance",
      "Total Dues",
      "Breakup",
    ];

    const rows = editStaffData.map((item) => {
      const driver = item.driver_details?.[0] || {};
      const car = item.car_details?.[0] || {};
      const driverName = driver.name || "";
      const fleet = car.car_tagline || "";
      const carName = car.car_name || "";
      const ratePerDay = item.per_day_rent || 0;
      const paymentDay = item?.day || "";
      const lastPaymentDate = item.last_payment_date?.split("T")[0] || "";
      const lastDays = item.days_since_last_payment || "";
      const paymentMode = item.payment_mode || "";
      const totalBalance = item.total_amount?.toFixed(2) || "0.00";
      const totalDues = item.total_due?.toFixed(2) || "0.00";
      const breakup = `Rent: ${item.due_rent?.toFixed(2) || "0.00"}, Tolls: ${
        item.due_tolls?.toFixed(2) || "0.00"
      }, Damage: ${item.due_damage?.toFixed(2) || "0.00"}, Tickets: ${
        item.due_ticket?.toFixed(2) || "0.00"
      }, Deposit: ${item.due_deposit?.toFixed(2) || "0.00"}, Others: ${
        item.due_other_charges?.toFixed(2) || "0.00"
      }`;

      return [
        driverName,
        fleet,
        carName,
        ratePerDay,
        paymentDay,
        lastPaymentDate,
        lastDays,
        paymentMode,
        totalBalance,
        totalDues,
        breakup,
      ];
    });

    // Add the top row with update date and time
    const updatedTime = `Updated at ${new Date().toLocaleDateString()} ${new Date().toLocaleTimeString(
      [],
      { hour: "2-digit", minute: "2-digit" }
    )}`;
    const mergedHeaderRow = [updatedTime];
    const allRows = [mergedHeaderRow, headers, ...rows];

    const worksheet = XLSX.utils.aoa_to_sheet(allRows);

    // Merge the first row across all columns
    worksheet["!merges"] = [
      {
        s: { r: 0, c: 0 },
        e: { r: 0, c: headers.length - 1 },
      },
    ];

    // Set column widths
    worksheet["!cols"] = [
      { wch: 20 },
      { wch: 20 },
      { wch: 15 },
      { wch: 15 },
      { wch: 15 },
      { wch: 20 },
      { wch: 18 },
      { wch: 15 },
      { wch: 15 },
      { wch: 40 },
    ];

    // Apply borders and styling
    const range = XLSX.utils.decode_range(worksheet["!ref"]);
    for (let R = range.s.r; R <= range.e.r; ++R) {
      for (let C = range.s.c; C <= range.e.c; ++C) {
        const cellAddress = XLSX.utils.encode_cell({ r: R, c: C });
        const cell = worksheet[cellAddress];
        if (!cell) continue;

        cell.s = {
          border: {
            top: { style: "thin", color: { rgb: "000000" } },
            bottom: { style: "thin", color: { rgb: "000000" } },
            left: { style: "thin", color: { rgb: "000000" } },
            right: { style: "thin", color: { rgb: "000000" } },
          },
          font: {},
        };

        // Bold only the second row (actual headers)
        if (R === 1) {
          cell.s.font.bold = true;
        }

        // Center align first row (merged)
        if (R === 0) {
          cell.s.alignment = { horizontal: "center" };
        }
      }
    }

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Driver Ledger");

    const wbout = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
      cellStyles: true,
    });

    const blob = new Blob([wbout], { type: "application/octet-stream" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "Driver_Ledger.xlsx";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  };

  const [sortField, setSortField] = useState(null);
  const [sortOrder, setSortOrder] = useState("asc");

  const applySorting = (data, field, order) => {
    return [...data].sort((a, b) => {
      const aBooking = a.booking_details?.[0] || {};
      const bBooking = b.booking_details?.[0] || {};

      const getValue = (row) => {
        const booking = row.booking_details?.[0] || {};
        switch (field) {
          case "dues":
            return row.total_due || 0;
          case "per_day_rate":
            return row.per_day_rent || 0;
          case "rent":
            return row.rent || 0;
          case "total_amount":
            return row.total_amount || 0;
          case "advance":
            return row.deposit || 0;
          case "tolls":
            return row.tolls || 0;
          case "damage":
            return row.damagefees || 0;
          default:
            return 0;
        }
      };

      const aVal = getValue(a);
      const bVal = getValue(b);

      return order === "asc" ? aVal - bVal : bVal - aVal;
    });
  };

  const handleSortChange = (field, order) => {
    setSortField(field);
    setSortOrder(order);

    const sorted = applySorting(filteredData, field, order);
    setfilteredData(sorted);
  };

  return (
    <div className="dashboard">
      {showLoaderAdmin && <Loader />}

      <div className="dashboard_container">
        <div className="page_content">
          <div className="page_content_container">
            <Header />
            <div className="pageCntn_head">
              <div className="pageNameDiv">
                <p className="breadcrumb-item">Booking Reports</p>
                <img src={GreyArrow} alt="Rapid Car Leasing" />
              </div>
              <div className={` alignCol bottomAlgin col-xl-3 mb-0`}>
                <div className="pageActionBtns">
                  <button
                    className="CSVBTN"
                    style={{ height: "38px" }}
                    onClick={downloadCSV}
                  >
                    Download Excel
                  </button>
                </div>
              </div>
              <Button
                onClick={goBack}
                startIcon={
                  <ArrowLeft size={17} style={{ marginBottom: "2px" }} />
                }
                className="Back_bttn_page"
              >
                Back
              </Button>
            </div>

            <div className="page_body">
              <div className="viewStaff">
                <div className="viewStaff_head">
                  <div className="row m-0">
                    <div className="col-lg-3 col-sm-4 bottomAlgin">
                      <div className="inputDiv2">
                        <label style={{ whiteSpace: "nowrap" }}>
                          <img src={FilterIcon} alt="Rapid Car Leasing" />
                          {/* Sort By:{" "} */}
                        </label>
                        <select
                          onChange={(e) => {
                            const [field, order] = e.target.value.split(":");
                            handleSortChange(field, order);
                          }}
                        >
                          <option value="">Sort By</option>
                          <option value="dues:asc">Dues (Low to High)</option>
                          <option value="dues:desc">Dues (High to Low)</option>
                          <option value="per_day_rate:asc">
                            Per Day Rate (Low to High)
                          </option>
                          <option value="per_day_rate:desc">
                            Per Day Rate (High to Low)
                          </option>
                          <option value="rent:asc">Rent (Low to High)</option>
                          <option value="rent:desc">Rent (High to Low)</option>
                          <option value="total_amount:asc">
                            Total Amount (Low to High)
                          </option>
                          <option value="total_amount:desc">
                            Total Amount (High to Low)
                          </option>
                          <option value="advance:asc">
                            Advance (Low to High)
                          </option>
                          <option value="advance:desc">
                            Advance (High to Low)
                          </option>
                          <option value="tolls:asc">Tolls (Low to High)</option>
                          <option value="tolls:desc">
                            Tolls (High to Low)
                          </option>
                          <option value="damage:asc">
                            Damage (Low to High)
                          </option>
                          <option value="damage:desc">
                            Damage (High to Low)
                          </option>
                        </select>
                      </div>
                    </div>

                    <div
                      className="col-xl-3 col-md-4 bottomAlgin"
                      style={{ marginLeft: "auto", marginRight: "0" }}
                    >
                      <div className="inputDiv2">
                        <label className="labelPointer" htmlFor="selectFilter">
                          <img src={Search} alt="Rapid Car Leasing" />
                        </label>
                        <input
                          type="text"
                          placeholder={GuestManagementPageText.Guest_Filter}
                          value={searchfilter}
                          // onInput={handleIaphabetnumberChange}
                          onChange={(e) => handleSearch(e)}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div style={{ padding: "0 10px" }}>
                  <div className="cust_hist_card" style={{ padding: "0 10px" }}>
                    <div className="reservationHistoryTable">
                      <div
                        className="historyTableContainer stickyTableheigh274"
                        style={{ overflowX: "auto" }}
                      >
                        <table className="table margin_class_table">
                          <thead className="stickyHeaderClss">
                            <tr>
                              <th scope="col">Sr.No.</th>
                              <th scope="col">
                                <div
                                  style={{
                                    display: "flex",
                                    flexDirection: "row",
                                    alignItems: "center",
                                  }}
                                >
                                  <img
                                    src={GuestIcon}
                                    alt="Rapid Car Leasing"
                                    style={{ height: "20px", width: "20px" }}
                                  />
                                  <span className="fontWeight600">
                                    Driver Name
                                  </span>
                                </div>
                              </th>
                              <th scope="col">Fleet</th>
                              <th scope="col">Car Name</th>
                              <th scope="col">Rate/day</th>
                              <th scope="col">Payment Day</th>
                              <th scope="col">Last Pay</th>
                              <th scope="col">Days</th>
                              <th scope="col">Mode</th>
                              <th scope="col">Total Balance</th>
                              <th scope="col">Total Dues</th>
                              <th scope="col">Breakup</th>
                            </tr>
                          </thead>
                          <tbody>
                            {currentItems && currentItems.length > 0 ? (
                              currentItems.map((option, index) => (
                                <tr
                                  className="historyTableRow h-auto"
                                  key={index}
                                >
                                  <td>
                                    <div
                                      className="historyTableRowText height50 historyName"
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                      }}
                                    >
                                      {indexOfFirstItem + index + 1}
                                    </div>
                                  </td>
                                  <td>
                                    <div className="historyTableRowText justify-content-start height50 historyName">
                                      <strong>
                                        {option?.driver_details[0]?.name}
                                      </strong>
                                      {option?.driver_details[0]?.email}
                                      <br />
                                      {option?.driver_details[0]?.mobile_no}
                                    </div>
                                  </td>
                                  <td>
                                    <div className="historyTableRowText justify-content-start height50 historyName">
                                      {option?.car_details[0]?.car_tagline}
                                    </div>
                                  </td>
                                  <td>
                                    <div className="historyTableRowText justify-content-start height50 historyName">
                                      {option?.car_details[0]?.car_name}
                                    </div>
                                  </td>
                                  <td>
                                    <div className="historyTableRowText justify-content-start height50 historyName">
                                      {option?.per_day_rent +
                                        option?.per_day_surcharges}
                                    </div>
                                  </td>
                                  <td>
                                    <div className="historyTableRowText justify-content-start height50 historyName">
                                      {option?.day}
                                    </div>
                                  </td>
                                  <td>
                                    <div className="historyTableRowText justify-content-start height50 historyName">
                                      {option?.last_payment_date == null
                                        ? "-"
                                        : mondayDayYearFormat(
                                            option?.last_payment_date
                                          )}
                                    </div>
                                  </td>
                                  <td>
                                    <div className="historyTableRowText justify-content-start height50 historyName">
                                      {option.days_since_last_payment || "-"}
                                    </div>
                                  </td>
                                  <td>
                                    <div className="historyTableRowText justify-content-start height50 historyName">
                                      <span
                                        className={`modeStyles ${
                                          option?.payment_mode == "stripe"
                                            ? "accounting-stripe"
                                            : option?.payment_mode == "cash"
                                            ? "accounting-cash "
                                            : option?.payment_mode == "zelle"
                                            ? "accounting-zelle"
                                            : "NA"
                                        }`}
                                      >
                                        {option?.payment_mode || "NA"}
                                      </span>
                                    </div>
                                  </td>
                                  <td>
                                    <div
                                      className="historyTableRowText justify-content-start historyPerson"
                                      style={{ flexWrap: "wrap" }}
                                    >
                                      <p style={{ color: "green" }}>
                                        $
                                        {option?.total_amount?.toFixed(2) ||
                                          "0.00"}
                                      </p>
                                    </div>
                                  </td>
                                  <td>
                                    <div
                                      className="historyTableRowText justify-content-start historyPerson"
                                      style={{ flexWrap: "wrap" }}
                                    >
                                      <p style={{ color: "red" }}>
                                        $
                                        {option?.total_due?.toFixed(2) ||
                                          "0.00"}
                                      </p>
                                    </div>
                                  </td>
                                  <td>
                                    <div
                                      className="historyTableRowText justify-content-start historyPerson"
                                      style={{ flexWrap: "wrap" }}
                                    >
                                      <p>
                                        <strong style={{ color: "green" }}>
                                          Rent:
                                        </strong>{" "}
                                        $
                                        {option?.due_rent?.toFixed(2) || "0.00"}
                                      </p>
                                      <p>
                                        <strong style={{ color: "orange" }}>
                                          Tolls:
                                        </strong>{" "}
                                        $
                                        {option?.due_tolls?.toFixed(2) ||
                                          "0.00"}
                                      </p>
                                      <p>
                                        <strong style={{ color: "red" }}>
                                          Damage:
                                        </strong>{" "}
                                        $
                                        {option?.due_damage?.toFixed(2) ||
                                          "0.00"}
                                      </p>
                                    </div>
                                  </td>
                                </tr>
                              ))
                            ) : (
                              <tr>
                                <td colSpan={12} className="text_align_center">
                                  No Results Found
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                        <div className="cust_hist_card_footer">
                          <div className="cust_hist_pagination_info">
                            {filteredData && filteredData.length > 0 ? (
                              <>
                                Showing{" "}
                                <span className="cust_hist_pagination_bold">
                                  {indexOfFirstItem + 1}
                                </span>{" "}
                                to{" "}
                                <span className="cust_hist_pagination_bold">
                                  {Math.min(
                                    indexOfLastItem,
                                    filteredData.length
                                  )}
                                </span>{" "}
                                of{" "}
                                <span className="cust_hist_pagination_bold">
                                  {filteredData.length}
                                </span>{" "}
                                Drivers
                              </>
                            ) : (
                              <>
                                Showing{" "}
                                <span className="cust_hist_pagination_bold">
                                  0
                                </span>{" "}
                                Driver
                              </>
                            )}
                          </div>
                          <div className="cust_hist_pagination">
                            <nav aria-label="Pagination">
                              <ul className="cust_hist_pagination_list">
                                {renderPaginationButtons()}
                              </ul>
                            </nav>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default BookingsReport;
